import { h, FunctionComponent } from 'preact';
import { ReachTabPanels } from 'components/Reach';
import { PanelContainer } from './Tabs.styles';

export interface TabPanelsProps {
  children?: any;
}

const TabPanels: FunctionComponent<TabPanelsProps> = ({ children }) => {
  return (
    <ReachTabPanels>
      <PanelContainer>{children}</PanelContainer>
    </ReachTabPanels>
  );
};

export default TabPanels;
